import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColore = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 11" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-11",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					id: "icon_Background",
					x: 0,
					y: 0,
					width: 1e3,
					height: 1e3
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "colore",
					transform: "translate(252.000000, 260.000000)",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M67,349 L94.5,260 L218.5,260 L246.5,349 L315,349 L199,0 L117,0 L0,349 L67,349 Z M202.5,203.5 L110.5,203.5 L155,60 L157.5,60 L202.5,203.5 Z",
							id: "A",
							fill: "#424548",
							fillRule: "nonzero"
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Color",
							fill: "#FEE17F",
							x: 384.444444,
							y: 369.333333,
							width: 111.111111,
							height: 111.111111
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Color",
							fill: "#FF9C9C",
							x: 273.333333,
							y: 258.222222,
							width: 111.111111,
							height: 111.111111
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Color",
							fill: "#1973E1",
							x: 384.444444,
							y: 258.222222,
							width: 111.111111,
							height: 111.111111
						}),
						/* @__PURE__ */ _jsx("rect", {
							id: "Color",
							fill: "#95D150",
							x: 273.333333,
							y: 369.333333,
							width: 111.111111,
							height: 111.111111
						})
					]
				}),
				/* @__PURE__ */ _jsx("polygon", {
					id: "Rectangle-Copy-14",
					fill: "#0056C1",
					points: "944.444444 833.333333 944.444444 944.444444 833.333333 944.444444"
				})
			]
		})
	})]
});
export default SvgColore;
